export default "__VITE_ASSET__CjEN9$mS__"